const DEFAULT_URL = '/ai/bot_functions'

// Cache one in-flight/resolved promise per source URL, so callers that request a filtered list
// (e.g. merchant-configured tools only) don't collide with the full-list cache.
const cachedPromises = {}

export function fetchBotFunctions(url = DEFAULT_URL) {
  if (!cachedPromises[url]) {
    cachedPromises[url] = fetch(url)
      .then(response => response.json())
      .then(data => data.functions)
      .catch(error => {
        console.error('Failed to fetch bot functions:', error)
        cachedPromises[url] = null
        return []
      })
  }
  return cachedPromises[url]
}
